<script lang="ts" setup>
import { Button } from '@collector/shared-ui'
import { Route } from '@desktop/router/routes'
</script>

<template>
  <div
    class="back-to-relation hover:bg-neutral-light-9 flex w-fit cursor-pointer items-center gap-2 rounded-md pr-1 text-lg transition-colors"
    @click="$router.push({ name: Route.RelationMain })"
  >
    <Button
      class="bg-neutral-light-7 border-neutral-light-0 enabled:hover:bg-neutral-light-3 enabled:active:bg-neutral-light-0 text-neutral-dark-2 cursor-pointer font-bold transition-colors active:transition-none"
      size="sm"
      icon="chevron-left"
      square
    />
    Back to Relation view
  </div>
</template>

<style scoped lang="scss">
.back-to-relation {
  &:hover :deep(button) {
    @apply bg-neutral-light-5;
  }
  &:active {
    @apply bg-neutral-light-8;
    @apply transform-none;
    :deep(button) {
      @apply bg-neutral-light-4;
      @apply transform-none;
    }
  }
}
</style>
